import React from "react"
import { useConfig } from "../app-core/_common/hooks/use-config"

const VisibleInLocal: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
    const { NODE_ENV } = useConfig()
    if (NODE_ENV !== "development") return null

    return <>{children}</>
}

export default VisibleInLocal
